export default {
  refresh: () => {
    if (CCRZ.currentUser && CCRZ.currentUser.UserType !== 'Guest') {
      $('#goToAccount').removeClass('goToLogin');
    }
  },
};
